import classNames from 'classnames';
import * as React from 'react';
import {useIntl} from 'react-intl';

import styles from './EventAnnotation.less';
import {
  ENCOUNTER_DOCUMENT_ROUTE,
  ENCOUNTER_ROUTE,
} from 'src/js/containers/encounter/encounter_constants';
import {DocumentLink} from 'src/js/containers/file/components/DocumentLink';
import {
  baseEventAnnotationParams,
  BaseEventAnnotationParams,
} from 'src/js/lib/raw_rendering/base_event_annotation_params';

interface OwnProps extends BaseEventAnnotationParams {}

type Props = OwnProps;

export const EventAnnotation: React.FC<Props> = (props) => {
  const intl = useIntl();
  const {
    annotation,
    encounterId,
    documentId,
    colorStyle,
    label,
    searchParams,
    titleText,
  } = baseEventAnnotationParams(props, {intl});

  return (
    <div className={styles.dlEventAnnotation} style={annotation.getStyle()}>
      {annotation.getDocumentId() ? (
        <DocumentLink
          documentDetailRoute={`${ENCOUNTER_ROUTE}/${encounterId}${ENCOUNTER_DOCUMENT_ROUTE}/${documentId}`}
          titleText={titleText}
          searchParams={searchParams}
          suppressPadding
        >
          <span
            className={classNames(
              styles.dlAnnotationLabel,
              styles.dlEventAnnotationPadding
            )}
            style={colorStyle}
          >
            {label}
          </span>
        </DocumentLink>
      ) : (
        <span className={styles.dlEventAnnotationPadding} style={colorStyle}>
          {label}
        </span>
      )}
    </div>
  );
};

EventAnnotation.displayName = 'EventAnnotation';
